module.exports = __webpack_public_path__ + "static/media/esp1.6d64b3d5.jpg";